/** @format */

import { UIRow, UICol } from "@rstore-react-packages/template-ui";
import { Button, Form, Select } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionMassiveStorePartnerRequest } from "../../../../redux-modules/actions/actionsStore";
import { useLanguage } from "../../../../redux-modules/hooks/useLanguage";
import { selectorPartnerListForTables } from "../../../../redux-modules/selectors/selectorsPartner";
import StyledModal from "../../../ui/Modal";
const { Option } = Select;

/** @format */
interface Props {
  visible: boolean;
  handleOk?: () => void;
  handleCancel?: () => void;
  store: number[];
}
const ModalChangeStorePartner = ({
  visible = false,
  handleCancel,
  handleOk,
  store,
}: Props): JSX.Element => {
  const l = useLanguage();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const partners = useSelector(selectorPartnerListForTables);

  const handleFinish = (form): void => {
    dispatch(
      actionMassiveStorePartnerRequest({
        users_ids: store,
        action: "partner",
        partner_id: form.partner_id,
      }),
    );
    //@ts-ignore
    handleOk && handleOk();
  };

  const handleReturn = (): void => {
    handleCancel && handleCancel();
  };

  return (
    <StyledModal
      title={l("editPartner")}
      visible={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleReturn}>
          Return
        </Button>,
        <Button key="submit" onClick={(): void => form.submit()}>
          Submit
        </Button>,
      ]}
    >
      <UIRow>
        <UICol xs={24}>
          <Form form={form} name="edit-store-partner" layout="horizontal" onFinish={handleFinish}>
            <Form.Item
              name="partner_id"
              label={"You are editing " + store.length + "'s store partner with:"}
            >
              <Select
                optionFilterProp="label"
                showSearch
                filterOption={(input, option): boolean =>
                  //@ts-ignore
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {partners.map(partner => (
                  <Option value={partner.value} key={partner.key}>
                    {partner.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </UICol>
      </UIRow>
    </StyledModal>
  );
};
export default ModalChangeStorePartner;
